import { render, staticRenderFns } from "./MonitoringAndConfigurationPrintPage2.vue?vue&type=template&id=8818cf42"
import script from "./MonitoringAndConfigurationPrintPage2.vue?vue&type=script&lang=js"
export * from "./MonitoringAndConfigurationPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports